import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMicrophoneOff = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 19.5V23.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.562 16.465C12.3756 16.4883 12.1879 16.5 12 16.5V16.5C10.8065 16.5 9.66193 16.0259 8.81802 15.182C7.97411 14.3381 7.5 13.1935 7.5 12V11.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.06396 3.067C8.45358 2.3647 9.02404 1.77946 9.71616 1.37203C10.4083 0.964602 11.1968 0.749828 12 0.75V0.75C13.1934 0.75 14.338 1.22411 15.1819 2.06802C16.0259 2.91193 16.5 4.05653 16.5 5.25V12"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.128 18.841C14.1429 19.2771 13.0773 19.5016 12 19.5V19.5C10.0547 19.5352 8.1744 18.7996 6.76935 17.4538C5.3643 16.1079 4.54853 14.261 4.5 12.316V9.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4999 9.75V12.316C19.5004 13.25 19.3098 14.1743 18.9399 15.032"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 2.25L21 21"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMicrophoneOff.displayName = 'SvgMicrophoneOff';
export default SvgMicrophoneOff;
